package fr.frux.shared.presentation

import kotlin.time.Duration.Companion.days
import kotlin.time.Instant

enum class TreeSighting { NEVER_SEEN, SEEN_LONG_AGO, SEEN_RECENTLY }

/**
 * Seul endroit qui traduit le fait date du contrat (ADR 0025) en niveaux affichables. Le contrat
 * public ne porte aucun bareme : le seuil ci-dessous se change ici, sans migration ni rupture.
 *
 * Une photo sans observation vaut un passage ancien : quelqu'un s'est tenu devant l'arbre pour la
 * prendre, mais rien ne date ce passage.
 */
private val RECENT_WINDOW = 90.days

fun treeSighting(
    lastObservedAt: Instant?,
    photoUrl: String?,
    now: Instant,
): TreeSighting =
    when {
        lastObservedAt != null && now - lastObservedAt <= RECENT_WINDOW -> TreeSighting.SEEN_RECENTLY
        lastObservedAt != null -> TreeSighting.SEEN_LONG_AGO
        !photoUrl.isNullOrBlank() -> TreeSighting.SEEN_LONG_AGO
        else -> TreeSighting.NEVER_SEEN
    }
